// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReviewList__container___2NKdC{margin:83px 0 120px}.ReviewList__inner___1_yVI{display:grid;grid-template-columns:repeat(3,1fr);justify-items:center;max-width:1330px;margin:0 auto}@media (max-width:1279px){.ReviewList__inner___1_yVI{grid-template-columns:repeat(2,1fr);max-width:780px}}@media (max-width:719px){.ReviewList__inner___1_yVI{grid-template-columns:repeat(1,1fr)}}.ReviewList__card___A7z6_{margin-bottom:40px}@media (max-width:1279px){.ReviewList__largeScreen___Hi62k{display:none}}@media (max-width:719px){.ReviewList__mediumScreen___2FHXV{display:none}}@media (min-width:1280px){.ReviewList__mediumScreen___2FHXV{display:none}}@media (min-width:720px){.ReviewList__smallScreen___22eNk{display:none}}.ReviewList__seeMore___Owa02{display:flex;justify-content:center;margin-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "ReviewList__container___2NKdC",
	"inner": "ReviewList__inner___1_yVI",
	"card": "ReviewList__card___A7z6_",
	"largeScreen": "ReviewList__largeScreen___Hi62k",
	"mediumScreen": "ReviewList__mediumScreen___2FHXV",
	"smallScreen": "ReviewList__smallScreen___22eNk",
	"seeMore": "ReviewList__seeMore___Owa02"
};
module.exports = ___CSS_LOADER_EXPORT___;
